module.exports = __webpack_public_path__ + "img/Asset 17@300x.png";